/** Word Wheel prototype display modes (phone vs tablet landscape). */

export const VIEW_PHONE = "phone";
export const VIEW_TABLET_LANDSCAPE = "tablet-landscape";

/** Capture / preview window sizes. */
export const WORD_WHEEL_VIEW_WINDOWS = {
    [VIEW_PHONE]: { width: 430, height: 940, label: "Phone version" },
    [VIEW_TABLET_LANDSCAPE]: { width: 1920, height: 1080, label: "1080P CONTENT" },
};

export function resolveWordWheelView(value) {
    const raw = typeof value === "string" ? value.trim().toLowerCase() : "";
    return raw === VIEW_TABLET_LANDSCAPE ? VIEW_TABLET_LANDSCAPE : VIEW_PHONE;
}

export function isTabletLandscapeView(view) {
    return resolveWordWheelView(view) === VIEW_TABLET_LANDSCAPE;
}

/**
 * Append or replace `?view=` on a path. Phone omits the param for cleaner URLs.
 * Preserves other query params when `path` already has a query string.
 */
export function withWordWheelView(path, view) {
    const mode = resolveWordWheelView(view);
    const raw = typeof path === "string" ? path : "";
    const qIndex = raw.indexOf("?");
    const base = qIndex >= 0 ? raw.slice(0, qIndex) : raw;
    const existing = qIndex >= 0 ? raw.slice(qIndex + 1) : "";
    const params = new URLSearchParams(existing);
    if (mode === VIEW_PHONE) {
        params.delete("view");
    } else {
        params.set("view", mode);
    }
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
}
